import { styled, Button } from '@mui/material';

export const DivProcessStatus = styled('div')({
  display: 'flex',
  justifyContent: 'left',
});

export const Span = styled('span')({
  marginLeft: '10px',
});

export const ProcessTitle = styled('h5')({
  margin: '0',
  fontWeight: 'bold',
});

export const ProcessDescription = styled('h3')({
  margin: '0',
  fontWeight: 'bold',
});

export const ArchiveButton = styled(Button)({
  marginLeft: '20px',
});
